var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card-dashboard",
      class: [{ clickable: _vm.clickable }],
      style: { color: _vm.color },
      on: { click: _vm.clickCard }
    },
    [
      _c("div", { staticClass: "title" }, [
        _c("span", [_vm._v(_vm._s(_vm.title))])
      ]),
      _c(
        "div",
        { staticClass: "content", style: { marginTop: this.marginTop } },
        [
          _c("span", { staticClass: "text" }, [_vm._v(_vm._s(_vm.content))]),
          _vm.icon ? _c("i", { class: _vm.icon }) : _vm._e(),
          _vm.image ? _c("img", { attrs: { src: _vm.image } }) : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a69e373", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a69e373","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppCardDashboard.vue
// module id = null
// module chunks = 